import React from 'react';

import './more-posts.styles.scss';

export const MorePosts = ({handleClick}) => {
    return (
        <div className="btn-wrapper">
          <button className="btn btn-hollow blue" onClick={handleClick}>Load More Posts</button>
        </div>
    )
}